"use client";

import { cn } from "@/lib/utils";

type SliderPaginationProps = {
  count: number;
  current: number;
  onChange: (index: number) => void;
  className?: string;
};

export const SliderPagination = ({
  count,
  current,
  onChange,
  className,
}: SliderPaginationProps) => {
  return (
    <div className={cn("hidden justify-center gap-1.5 px-3.5 sm:flex", className)}>
      {Array.from({ length: count }).map((_, index) => (
        <button
          key={index}
          className="group relative -mx-3.5 flex size-12 items-center justify-center focus-visible:outline-none"
          onClick={() => onChange(index)}
          aria-label={`Go to slide ${index + 1}`}
        >
          <span
            className={cn("bg-primary/50 size-2.5 rounded-full transition-all duration-300", {
              "bg-primary w-6": index === current,
            })}
          />
        </button>
      ))}
    </div>
  );
};
